export var AffectedLeaves;
(function (AffectedLeaves) {
    AffectedLeaves["Young"] = "young";
    AffectedLeaves["Old"] = "old";
    AffectedLeaves["All"] = "all";
})(AffectedLeaves || (AffectedLeaves = {}));
